module.exports = __webpack_public_path__ + "img/service-bg.e36d783c.webp";